import { Mountain, Building2, Cable, BrickWall, PaintRoller, FlaskConical, Fence, TrafficCone, LayoutGrid, Boxes } from "lucide-react";

export const PHASE_ICONS = { Mountain, Building2, Cable, BrickWall, PaintRoller, FlaskConical, Fence, TrafficCone, Boxes };

export function PhaseIcon({ name, size = 18, className = "" }) {
  const Icon = PHASE_ICONS[name] || LayoutGrid;
  return <Icon size={size} className={className} />;
}

export function PhaseRail({ phases, active, onSelect, total }) {
  const tile = (selected) =>
    `group relative flex items-center gap-3 rounded-sm border px-4 py-3 text-left transition-colors ${
      selected ? "border-[#B87333] bg-[#B87333]/10" : "border-white/10 hover:border-[#B87333]/60"
    }`;
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 pb-8" data-testid="phase-rail">
      <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-10 gap-2">
        <button data-testid="phase-all" onClick={() => onSelect(null)} className={tile(active === null)}>
          <LayoutGrid size={18} className={active === null ? "text-[#B87333]" : "text-[#8A8A82] group-hover:text-[#B87333]"} />
          <div className="min-w-0">
            <div className="font-grotesk text-[10px] uppercase tracking-[0.18em] text-[#8A8A82]">All</div>
            <div className="font-serif text-sm leading-tight truncate">{total} SKUs</div>
          </div>
        </button>
        {phases.map((ph) => (
          <button key={ph.phase} data-testid={`phase-${ph.phase}`} title={ph.label} onClick={() => onSelect(ph.phase)} className={tile(active === ph.phase)}>
            <PhaseIcon name={ph.icon} className={active === ph.phase ? "text-[#B87333]" : "text-[#8A8A82] group-hover:text-[#B87333]"} />
            <div className="min-w-0">
              <div className="font-grotesk text-[10px] uppercase tracking-[0.18em] text-[#8A8A82]">Phase {ph.phase}</div>
              <div className="font-serif text-sm leading-tight truncate">{ph.short}</div>
            </div>
            <span className="absolute top-1.5 right-2 font-grotesk text-[9px] text-[#8A8A82]">{ph.product_count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
